import Language from './language';
import { api, signalr } from '@/f1/service';
import AgentItem from '@/f1/views/WSFinder/DashboardItem/Agent.i18n';
import agent from '@/f1/views/WSFinder/agent/service'
import moment from 'moment-timezone';
import _ from "lodash";
import AnimatedNumber from "animated-number-vue";

//restful api
//import { wsfinder as wf } from '@/f1/service/api'
//import { wmds as ws } from '@/f1/service/api'

import i18n_data from '@/component/i18n_data';

export default {
  components : {
    AnimatedNumber,
    'agent-item' : AgentItem,
    Language
  },
  data: () => {
    return {
      th : undefined,
      agents : [],
      count : 0,
      // signalr : signalr.socket(),
      info : { day : 0, week : 0, month : 0 }
    }
  },
  computed : {},
  methods: {
    detail: function(item) { this.$router.push(`agent/${item.id}`); },
    get_info(r) {
      return new Promise(async (resolve, reject) => {
        let month = await api.wsfinder.WSFinder_Call('dashboard', 'week', { agent_id : r.id });
        //let month = await wf.dashboard.week({ agent_id : r.id }));
        if(month.is_error) {
          this.$toast.w('load failed')
          resolve([])
        }
        resolve(month.body)
      })
    },
    value_comma(v) { return (v.toFixed(0) || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") },
    default_info() { return { scan_count : 0, detect_count : 0, isolation_count : 0, total : 0 } },
    catch_msg(e) { console.error(e); this.$toastr.e(e.data ? `${i18n_data._i18n_error.password[this.i18n]}` : (e.data.message ? e.data.message : e.statusText)); },
    async load() {

      try {
        this.ping()

        api.wsfinder.WSFinder_Call("dashboard", "month").then(rs => {
        //wf.dashboard.month().then(rs => {
          let today = moment();

          this.info.day = Object.assign({}, this.default_info())
          this.info.week = Object.assign({}, this.default_info())
          this.info.month = Object.assign({}, this.default_info())

          for (let i = 0; i < rs.body.data.length; i++) {
            const r = rs.body.data[i];
            let rdate = moment(r.date);
            // console.log(rdate.month(), today.month())

            if(rdate.month() == today.month()) {
              // console.log('this.month', today, rdate, day)
              this.info.month.scan_count += r.scan_count;
              this.info.month.detect_count += r.detect_count;
              this.info.month.isolation_count += r.isolation_count;
            }

            let day = moment.duration(rdate.diff(today)).asDays()

            if(day >= -7 && day < 0) {
              // console.log('week', today, rdate, day)
              this.info.week.scan_count += r.scan_count;
              this.info.week.detect_count += r.detect_count;
              this.info.week.isolation_count += r.isolation_count;
            }
            if(day >= -1 && day < 0) {
              // console.log('day', today, rdate, day)
              this.info.day.scan_count += r.scan_count;
              this.info.day.detect_count += r.detect_count;
              this.info.day.isolation_count += r.isolation_count;
            }
          }

        }).catch(e => this.catch_msg(e));

        api.wsfinder.WSFinder_Call("dashboard", "agent").then(rs => {
        //wf.dashboard.agent().then(rs => {
          this.info.module = { alive : 0, deleted : 0 };
          if(rs.is_error) { return this.$toastr.e(`${i18n_data._i18n_error.load_failed[this.i18n]}`) }
          this.info.module.alive = rs.body.data.total - rs.body.data.deleted
          this.info.module.deleted = rs.body.data.deleted

        }).catch(e => this.catch_msg(e));

        // _.forEach(this.$refs, x => { try {  console.log(x) && x && x.play && x.indexOf('_check_') > -1 && x.play() } catch (e) { console.log(e); }})

      } catch (e) { console.error(e) }

      try {

        let rs = await api.wsfinder.WSFinder_Call("agent", "list", { offset : 0, limit :  100, sort : [ { name : "id", op : "desc" } ], request: 'wsfinder' });
        //let rs = await wf.agent.list({ offset : 0, limit :  100, sort : [ { name : "id", op : "desc" } ], request: 'wsfinder' });
        this.count = rs.total;
        this.agents = []

        // this.ping()
        for (let index = 0; index < rs.body.length; index++) {
          const r = rs.body[index];

          let daily = await this.get_info(r)
          let total_scan = _.sumBy(daily.data, r =>r.scan_count)
          let total_detect = _.sumBy(daily.data, r =>r.scan_count_count)

          this.agents.push(Object.assign(r, { ms : 0, align : false, total_scan : (total_scan || 0), total_detect : (total_detect || 0) }))

        }

      } catch(e) { console.log(e) }
    },
    async ping() {
      // if(!this.agents || this.agents.length < 1) { return }
      if(this.agents && this.agents.length) {
        this.agents.forEach(r => {
          try {
            agent.ws.Cmd("ping", r.id).then(x => this.res_ping_ws(x));
            agent.ws.Cmd("status", r.id).then(x => this.res_ping_ws(x));
          } catch(e) { console.log(e) }
        })
      }
      // for (let i = 0; i < this.agents.length; i++) {
      //   // agent.Cmd("ping", this.agents[i].id)
      //   // agent.Cmd("status", this.agents[i].id)
      //   // agent.ws.Cmd("ping", `${this.agents[i].id}`).then(rs => this.res(rs));
      //   // agent.ws.Cmd("status", `${this.agents[i].id}`).then(rs => this.res(rs));
      //   agent.ws.Cmd("ping", `${this.agents[i].id}`)
      //   agent.ws.Cmd("status", `${this.agents[i].id}`)
      // }
      if(this.th) { clearTimeout(this.th); } // 초기화
      this.th = undefined
      this.th = setTimeout(this.ping, 3000);
    },
    res_ping_ws(m) {
      if(m.cmd != 'status' && m.cmd != 'pong') { return; }
      if(m.cmd == 'pong') {
        _.filter(this.agents, { id : m.agent_id }).forEach(a => {
          let update = { ms : Math.abs(new Date().getTime() - Number(m.body)), alive : true }
          this.agents[_.findIndex(this.agents, { id : m.agent_id })] = _.assign(a, update);
        });
      } else {
        m.body = typeof '' == typeof m.body ? JSON.parse(m.body) : m.body
        _.filter(this.agents, { id : m.agent_id }).forEach(a => {
          let update = { progress : ((m.body.scan_count/(m.body.scan_count_left+m.body.scan_folder_left)) * 100), scanning : m.body.running }
          if(m.body.running === false && this.agents[_.findIndex(this.agents, { id : m.agent_id })].scanning === true) {
            this.$toastr.i(`${i18n_data._i18n_info.response_handler[this.i18n]}`, this.agents[_.findIndex(this.agents, { id : m.agent_id })].name)
          }
          this.agents[_.findIndex(this.agents, { id : m.agent_id })] = _.assign(a, update);
        });
      }
    },
  },
  async mounted () {
    console.log('dashboard.vue mounted');
    signalr.subscribe('wsfinder_response', this.res_ping_ws);
    if(this.th) { clearTimeout(this.th); this.th = undefined; }
    this.load();
    // this.signalr.on('wsfinder_response', this.res);
  },
  destroyed () {
    console.log('dashboard.vue destroyed');
    // this.signalr.off('wsfinder_response');
    if(this.th) { clearTimeout(this.th); this.th = undefined; }
  },
  watch : {
    '$route' (to, from) { this.load(to.params.id, from) }
  }
}
